import CBLFiltersComponent from "./CBLFiltersComponent";
import CBLStatsComponent from "./CBLStatsComponent";
import CBLTableComponent from "./CBLTableComponent";

const ChargeableBookingsList = () => {
  return (
    <div className="">
      <div className="relative px-4 py-2 2xl:py-4 rounded-md">
        <h3 className="text-sm text-black font-semibold mb-2 sm:mb-2 2xl:mb-4">
          Advance Payment Bookings List
        </h3>
        <CBLStatsComponent />
        <CBLFiltersComponent />
      </div>
      <CBLTableComponent />
    </div>
  );
};

export default ChargeableBookingsList;
